// @flow

import "normalize.css/normalize.css";

import styled, { injectGlobal, css } from "styled-components";

const containerSize = "800px";
export const media = {
  handheld: (...args: any) => css`
    @media (max-width: ${containerSize}) {
      ${css(...args)}
    }
  `
};

export const colors = {
  green: "#35cc35",
  grey: "#ccc"
};

/* eslint no-unused-expressions: off */
injectGlobal`
  body {
    margin: 0 auto;
    padding: 0;
    font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
    font-weight: 300;
    max-width: ${containerSize};
    color: #333;
    line-height: 1.5em;
  }

  h1, h2, h3, h4, h5 {
    font-weight: 300;
  }

  a {
    text-decoration: none;
    color: #4a90c5;
    font-weight: bold;

    &:visited, &:active, &:hover {
      color: #4a90c5;
      text-decoration: none;
    }
  }
`;

export const AppTitle = styled.h1`
  margin: 50px 0 20px 0;
  font-size: 3.2em;
  text-align: center;
  ${media.handheld`
    font-size: 2em;
  `}
`;

export const AppSubtitle = styled.div`
  margin: 0 auto;
  padding: 20px 30px 0 30px;
  max-width: 40em;
`;

export const SplitContainer = styled.div`
  display: flex;
  flex-direction: row;
  ${media.handheld`
    flex-direction: column;
  `}
`;

export const SplitChild = styled.div`
  flex: ${props => (props.narrow ? 0.5 : 1)};
  margin: 0 35px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const SectionTitle = styled.h2`
  font-size: 2em;
  margin-top: 40px;
  color: #0050b9;
  align-self: ${props => (props.centered ? "center" : "left")};

  ${"" /* &.centered {
    text-align: center;
  } */}
`;



// WEBPACK FOOTER //
// ./src/styles.js